import { render } from "./BottomNavigationItem.vue?vue&type=template&id=626c04d8"
import script from "./BottomNavigationItem.vue?vue&type=script&lang=js"
export * from "./BottomNavigationItem.vue?vue&type=script&lang=js"

import "./BottomNavigationItem.vue?vue&type=style&index=0&id=626c04d8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__